// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
// class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';
// service class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { ExcelService } from '../../../../services/infrastructure/excel.service';
import { OTIOrderLandingFilterVM } from '../../../../models/OTI/OTIOrderLandingFilterVM';
import { OtiService } from '../../../../services/oti/oti.service';
// Model class
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';
import { SOTService } from '../../../../services/seed/sot/sot.service';
import { StockTransferLandingFilterVM } from '../../../../models/StockTransfer/StockTransferLandingFilterVM';
import { Action, RequestStatusType } from './sot-landing-enum';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-sot-landing',
  templateUrl: './sot-landing.component.html',
  styleUrls: ['./sot-landing.component.scss'],
})
export class StockTransferLandingComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('sotRequestTable', { read: MatSort })
  sotRequestSort: MatSort;
  @ViewChild('sotRequestPaginator', { read: MatPaginator })
  sotRequestPaginator: MatPaginator;
  @ViewChild('sotToRequestTable', { read: MatSort })
  sotToRequestSort: MatSort;
  @ViewChild('sotToRequestPaginator', { read: MatPaginator })
  sotToRequestPaginator: MatPaginator;
  @ViewChild('sotRequestDraftTable', { read: MatSort })
  sotRequestDraftSort: MatSort;
  @ViewChild('sotRequestDraftPaginator', { read: MatPaginator })
  sotRequestDraftPaginator: MatPaginator;

  sotRequestDraftColumns: string[] = [];
  sotRequestColumns: string[] = [];
  sotToRequestColumns: string[] = [];
  draftRequestDataSource: MatTableDataSource<any>;
  sotRequestDataSource: MatTableDataSource<any>;
  sotToRequestDataSource: MatTableDataSource<any>;
  filters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  selectedTabIndex = 0;
  masterConstants = MasterConstants;
  filterOptionsData: Array<FilterOption>;
  subscription = new Subscription();
  filter: StockTransferLandingFilterVM = new StockTransferLandingFilterVM();
  sotRequestList: any = [];
  sotToRequestList: any = [];
  sotRequestDraftList: any = [];
  bannerMessage = '';
  tabNode = false;
  validateEvolveData: any;
  readOnlyAccess = false;
  CurrentTabSubscription: any;
  isPendingSelected = false;
  isSubmittedSelected = false;
  isShow: boolean;

  // set From table header data
  headerList: any = [
    {
      headertxt: 'Request #',
      columnfield: 'sotRequestNumber',
      className: 'mat-header-cell webOrderNumber',
      dataType: '',
      textFormat: '',
      cellAction: true,
      isAddress: false,
    },
    {
      headertxt: 'From Account Name',
      columnfield: 'fromAccountName',
      className: 'mat-header-cell locationDetails',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: true,
      CombineCol: [
        'fromAccountName',
        'fromAccountAddress1',
        'fromAccountAddress2',
        'fromAccountCity',
        'fromAccountState',
        'fromAccountZipCode',
      ],
    },
    {
      headertxt: 'From Account # ',
      columnfield: 'fromAccount',
      className: 'mat-header-cell accountNumber',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: 'To Account Name',
      columnfield: 'toAccountName',
      className: 'mat-header-cell locationDetails',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: true,
      CombineCol: [
        'toAccountName',
        'toAccountAddress1',
        'toAccountAddress2',
        'toAccountCity',
        'toAccountState',
        'toAccountZipCode',
      ],
    },
    {
      headertxt: 'To Account # ',
      columnfield: 'toAccount',
      className: 'mat-header-cell accountNumber',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: 'Customer PO#',
      columnfield: 'toCustPONumber',
      className: 'mat-header-cell custPONumber',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: 'Request Date',
      columnfield: 'fromRequestDate',
      className: 'mat-header-cell requestDate',
      dataType: 'date',
      textFormat: 'MM/dd/yyyy',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: 'Status',
      columnfield: 'requestStatus',
      className: 'mat-header-cell status',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: '',
      columnfield: 'contextMenu',
      className: 'mat-header-cell actionBtn',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
  ];

  // To list coloumns
  headerToList: any = [
    {
      headertxt: 'Request #',
      columnfield: 'sotRequestNumber',
      className: 'mat-header-cell webOrderNumber',
      dataType: '',
      textFormat: '',
      cellAction: true,
      isAddress: false,
    },
    {
      headertxt: 'From Account Name',
      columnfield: 'fromAccountName',
      className: 'mat-header-cell locationDetails',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: true,
      CombineCol: [
        'fromAccountName',
        'fromAccountAddress1',
        'fromAccountAddress2',
        'fromAccountCity',
        'fromAccountState',
        'fromAccountZipCode',
      ],
    },
    {
      headertxt: 'From Account # ',
      columnfield: 'fromAccount',
      className: 'mat-header-cell accountNumber',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: 'To Account Name',
      columnfield: 'toAccountName',
      className: 'mat-header-cell locationDetails',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: true,
      CombineCol: [
        'toAccountName',
        'toAccountAddress1',
        'toAccountAddress2',
        'toAccountCity',
        'toAccountState',
        'toAccountZipCode',
      ],
    },
    {
      headertxt: 'To Account # ',
      columnfield: 'toAccount',
      className: 'mat-header-cell accountNumber',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: 'Customer PO#',
      columnfield: 'fromCustPONumber',
      className: 'mat-header-cell custPONumber',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: 'Request Date',
      columnfield: 'toRequestDate',
      className: 'mat-header-cell requestDate',
      dataType: 'date',
      textFormat: 'MM/dd/yyyy',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: 'Status',
      columnfield: 'requestStatus',
      className: 'mat-header-cell status',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: '',
      columnfield: 'contextMenu',
      className: 'mat-header-cell actionBtn',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
  ];

  // set Draft table header data
  headerListDraft: any = [
    {
      headertxt: 'Request #',
      columnfield: 'sotRequestNumber',
      className: 'mat-header-cell webOrderNumber',
      dataType: '',
      textFormat: '',
      cellAction: true,
      isAddress: false,
    },
    {
      headertxt: 'From Account Name',
      columnfield: 'fromAccountName',
      className: 'mat-header-cell locationDetails',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: true,
      CombineCol: [
        'fromAccountName',
        'fromAccountAddress1',
        'fromAccountAddress2',
        'fromAccountCity',
        'fromAccountState',
        'fromAccountZipCode',
      ],
    },
    {
      headertxt: 'From Account # ',
      columnfield: 'fromAccount',
      className: 'mat-header-cell accountNumber',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: 'To Account Name',
      columnfield: 'toAccountName',
      className: 'mat-header-cell locationDetails',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: true,
      CombineCol: [
        'toAccountName',
        'toAccountAddress1',
        'toAccountAddress2',
        'toAccountCity',
        'toAccountState',
        'toAccountZipCode',
      ],
    },
    {
      headertxt: 'To Account # ',
      columnfield: 'toAccount',
      className: 'mat-header-cell accountNumber',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: 'Customer PO#',
      columnfield: 'fromCustPONumber',
      className: 'mat-header-cell custPONumber',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: 'Draft Date',
      columnfield: 'draftDate',
      className: 'mat-header-cell requestDate',
      dataType: 'date',
      textFormat: 'MM/dd/yyyy',
      cellAction: false,
      isAddress: false,
    },
    {
      headertxt: '',
      columnfield: 'contextMenuIcon',
      className: 'mat-header-cell status',
      dataType: '',
      textFormat: '',
      cellAction: false,
      isAddress: false,
      IsSingleAction: true,
      IconTitle: 'delete',
      OverideClass: 'icon-ico-trash handCursor',
    },
  ];

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private excelService: ExcelService,
    private sotService: SOTService,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private localStorageService: LocalStorageService,
    private matDialog: MatDialog,
    private commonService: CommonService,
    private otiService: OtiService
  ) { }

  ngOnInit(): void {
    this.bannerMessage = '';
    this.getFromLocalStorage();
    this.setReadOnlyAccess();
    this.getGridData();
    this.setFilterAndGridColumn();
    this.setDefaultFilter();
    this.setDropDownValues();

    if (window.screen.width >= 768) {
      this.isShow = true;
    }
    if (window.screen.width < 767) {
      this.isShow = false;
    }
  }

  getFromLocalStorage() {
    this.subscription.add(this.commonService.currentTabIndex.subscribe((val) => {
      this.selectedTabIndex = val;
    }));
  }

  setReadOnlyAccess() {
    this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SOT_STOCK_TRANSFERS);
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      {
        label: 'From Account No',
        key: 'fromAccountNumber',
        controlType: ControlType.Integer,
      },
      {
        label: 'From Account Name',
        key: 'fromAccountName',
        controlType: ControlType.Text,
      },
      {
        label: 'From Account City',
        key: 'fromAccountCity',
        controlType: ControlType.Text,
      },
      {
        label: 'To Account No',
        key: 'toAccountNumber',
        controlType: ControlType.Integer,
      },
      {
        label: 'To Account Name',
        key: 'toAccountName',
        controlType: ControlType.Text,
      },
      {
        label: 'To Account City',
        key: 'toAccountCity',
        controlType: ControlType.Text,
      },
      {
        label: 'Request Number',
        key: 'requestNumber',
        controlType: ControlType.Integer,
      },
      {
        label: 'Product Line',
        key: 'productLine',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Item Number',
        key: 'productNumber',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Customer PO',
        key: 'customerPO',
        controlType: ControlType.Text,
      },
      {
        label: 'Status',
        key: 'status',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'value',
      },
    ];
    this.getProductLine();
    this.getItemList();
  }

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      toAccountNumber: null,
      toAccountName: null,
      fromAccountNumber: null,
      fromAccountName: null,
      requestNumber: null,
      productName: null,
      productNumber: null,
      customerPO: null,
      status: null,
    };
  }

  // Set Drop down values for filter
  setDropDownValues() {
    if (MasterConstants.SOT_STATUS_LIST) {
      this.filterOptionsData.find((x) => x.key == 'status').controlData =
        MasterConstants.SOT_STATUS_LIST;
    }
  }

  // get product line for filter
  getProductLine() {
    this.subscription.add(this.sotService.getProductLineList().subscribe(
      (result) => {
        this.filterOptionsData.find((x) => x.key == 'productLine').controlData =
          result;
      },
      (error) => { }
    ));
  }

  getItemList() {
    this.subscription.add(this.sotService.getItemNumberList().subscribe((result: any[]) => {
      this.filterOptionsData.find((x) => x.key == 'productNumber').controlData =
        result;
    }));
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    this.setAccSummaryTableHeight();
  };

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight =
        window.innerHeight -
        $('.TopSec').outerHeight() -
        $('.form-sec').outerHeight() -
        $('.mat-tab-header').outerHeight() -
        $('.fulfill-top-sec').outerHeight() -
        250;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
      $('.draftReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  viewOrderToInvoice(element) {
    if (element.fromJDEOrderNumber != '' || element.toJDEOrderNumber != '' || element.freightJDEOrderNumber != ''
      || element.fromJDEOrderNumber != '0' || element.toJDEOrderNumber != '0' || element.freightJDEOrderNumber != '0') {
      const accountDs = [
        element.fromJDEOrderNumber,
        element.toJDEOrderNumber,
        element.freightJDEOrderNumber,
      ];
      const accountsPara = accountDs
        .filter((item, i, ar) => ar.indexOf(item) === i && item != '')
        .toString();
      //this.localStorageService.set(
      //  MasterConstants.OTI_SALESORDERNUMBER,
      //  accountsPara
      //);
      //this.router.navigate(['/cc/landing-data']);
      this.filters.salesOrderNumber = accountsPara;
      this.filters.dateInDays = 0;
      this.filters.fromOrderDate = element.draftDate !== null ? new Date(element.draftDate) : null;
      this.filters.toOrderDate = new Date();
      this.filters.orderStatus = null;
      this.filters.orderStatusText = "ALL";
      this.filters.productLineSegment = 'SEED';
      this.filters.dateRangeText = this.filters.fromOrderDate != null && this.filters.toOrderDate != null ? this.datePipe.transform(this.filters.fromOrderDate, 'MM/dd/yyyy')
        + ' - ' + this.datePipe.transform(this.filters.toOrderDate, 'MM/dd/yyyy') : "";
      this.otiService.setFilters(this.filters);
      this.router.navigate(['/order/dashboard']);
    }
    else {
      this.toastrService.error('Order Not Present For Review');
    }
    this.loaderService.setLoaderStatus(false);
  }

  // Delete draft request
  deletedraftrequest(SotRequest: any) {
    if (SotRequest) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Delete Draft Request',
          message: 'Do you want to delete this saved request?',
          labelYes: 'Yes',
          labelNo: 'No',
          dialogType: 'confirm',
        },
      });
      this.subscription.add(dialogRef.afterClosed().subscribe((result) => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.add(
            this.sotService
              .deleteDraftRequest(SotRequest.sotRequestId)
              .subscribe(
                (result) => {
                  if (result) {
                    this.toastrService.success(
                      'Draft order deleted successfully.'
                    );
                    this.getGridData();
                  }
                  this.loaderService.setLoaderStatus(false);
                },
                (error) => this.loaderService.setLoaderStatus(false)
              )
          );
        }
      }));
    }
  }

  // Cancel Order request
  cancelOrderRequest(SotRequest: any) {
    if (SotRequest) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Cancel Request',
          message: 'Do you want to cancel this request?',
          labelYes: 'Yes',
          labelNo: 'No',
          dialogType: 'confirm',
        },
      });
      this.subscription.add(dialogRef.afterClosed().subscribe((result) => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.add(
            this.sotService
              .cancelOrderRequest(SotRequest.sotRequestId)
              .subscribe(
                (result) => {
                  if (result) {
                    this.toastrService.success('Order Cancelled successfully.');
                    this.getGridData();
                  }
                  this.loaderService.setLoaderStatus(false);
                },
                (error) => this.loaderService.setLoaderStatus(false)
              )
          );
        }
      }));
    }
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  createNewStockTransfer() {
    this.router.navigate(['/sot-request-entry/']);
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getGridData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(
      this.sotService.getLandingGridList(this.filter).subscribe(
        (result: any[]) => {
          // From tab variables.
          this.GetFromTabGridData(result);

          // To tab variables.
          this.GetToTabGridData(result);

          // Draft tab variables.
          this.GetDraftTabGridData(result);
          this.resetPendingandSubmittedSelection();
          this.loaderService.setLoaderStatus(false);
        },
        (error) => {
          this.loaderService.setLoaderStatus(false);
          this.resetPendingandSubmittedSelection();
        }
      )
    );
  }

  // Search Action
  filterSearchClick(event) {
    this.filter = event;
    this.persistPendingandSubmittedSelection();
    this.getGridData();
  }

  persistPendingandSubmittedSelection() {
    if (Boolean(this.filter.status)) {
      if (this.filter.status.includes('PENDING') && this.filter.status.includes('SUBMITTED')) {
        this.isPendingSelected = true;
        this.isSubmittedSelected = true;
        const statusList = this.filter.status.split(',');
        const pendingIndex = statusList.indexOf('PENDING');
        delete statusList[pendingIndex];
        this.filter.status = statusList.join(',');
      }
      else if (this.filter.status.includes('PENDING') && !this.filter.status.includes('SUBMITTED')) {
        this.isPendingSelected = true;
        this.filter.status = this.filter.status.replace('PENDING', 'SUBMITTED');
      }
      else if (this.filter.status.includes('SUBMITTED')) {
        this.isSubmittedSelected = true;
      }
    }
  }

  resetPendingandSubmittedSelection() {
    if (Boolean(this.filter.status)) {
      if (this.isPendingSelected && this.isSubmittedSelected) {
        this.filter.status = this.filter.status + ',PENDING';
      }
      else if (this.isPendingSelected && !this.isSubmittedSelected) {
        this.filter.status = this.filter.status.replace('SUBMITTED', 'PENDING');
      }
      this.isSubmittedSelected = false;
      this.isPendingSelected = false;
    }
  }

  GetDraftTabGridData(result: any) {
    this.sotRequestDraftList = result.filter(
      (x) => x.gridType.toUpperCase() === 'D'
    );
    this.draftRequestDataSource = new MatTableDataSource(
      this.sotRequestDraftList
    );
    this.draftRequestDataSource.paginator = this.sotRequestDraftPaginator;
    this.draftRequestDataSource.sort = this.sotRequestDraftSort;
  }

  GetFromTabGridData(result: any) {
    this.sotRequestList = result.filter(
      (x) => x.gridType.toUpperCase() === 'F'
    );
    if (Boolean(this.filter.status) && !this.isPendingSelected) {
      this.sotRequestList = this.sotRequestList.filter(
        (x) => x.requestStatus !== RequestStatusType.Submitted
      );
    }
    this.sotRequestList.map((x) => {
      const actionType = [];
      actionType.push(Action.View_Order);
      x['Action'] = actionType;

      if (x.requestStatus === RequestStatusType.Submitted) {
        x.requestStatus = RequestStatusType.Pending;
      }

      return x;
    });
    this.sotRequestDataSource = new MatTableDataSource(this.sotRequestList);
    this.sotRequestDataSource.paginator = this.sotRequestPaginator;
    this.sotRequestDataSource.sort = this.sotRequestSort;
  }

  GetToTabGridData(result: any) {
    this.sotToRequestList = result.filter(
      (x) => x.gridType.toUpperCase() === 'T'
    );
    if (Boolean(this.filter.status) && !this.isSubmittedSelected) {
      this.sotToRequestList = this.sotToRequestList.filter(
        (x) => x.requestStatus !== RequestStatusType.Submitted
      );
    }
    this.sotToRequestList.map((x) => {
      const actionType = [];
      actionType.push(Action.View_Order);
      if (x.requestStatus === RequestStatusType.Pending) {
        actionType.push(Action.Cancel_Request);
      }
      if (x.requestStatus === RequestStatusType.Submitted) {
        actionType.push(Action.Cancel_Request);
      }
      if (x.requestStatus === RequestStatusType.Rejected) {
        actionType.push(Action.Cancel_Request);
      }
      if (x.requestStatus === RequestStatusType.Editing) {
        actionType.push(Action.Cancel_Request);
      }
      x['Action'] = actionType;
      return x;
    });
    this.sotToRequestDataSource = new MatTableDataSource(this.sotToRequestList);
    this.sotToRequestDataSource.paginator = this.sotToRequestPaginator;
    this.sotToRequestDataSource.sort = this.sotToRequestSort;
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.getGridData();
  }

  OnActionPerform(data: any) {
    switch (data.event) {
      case Action.Delete_Request:
        this.deletedraftrequest(data.rowData);
        break;
      case Action.Cancel_Request:
        this.cancelOrderRequest(data.rowData);
        break;
      case Action.View_Order:
        this.viewOrderToInvoice(data.rowData);
    }
  }

  createNewOrder(data: any, currentTab: number) {
    this.router.navigate(['/sot-request-entry']);
    this.commonService.currentTabIndex.next(this.selectedTabIndex);
  }

  updateExistingOrder(data: any) {
    this.loaderService.setLoaderStatus(true);
    this.commonService.currentTabIndex.next(this.selectedTabIndex);

    if (data.rowData.gridType.toUpperCase() === 'F') {
      this.router.navigate([
        '/sot-request-review/' + data.rowData.sotRequestId + '/' + 0,
      ]);
    }
    else if (data.rowData.gridType.toUpperCase() === 'T' && data.rowData.requestStatus === 'SUBMITTED') {
      this.router.navigate([
        '/sot-request-review/' + data.rowData.sotRequestId + '/' + 1,
      ]);
    }
    else {
      this.sotService.setSOTRequestId(+data.rowData.sotRequestId);
      this.router.navigate(['/sot-request-entry']);
    }
    this.loaderService.setLoaderStatus(false);
  }

  export() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(
      this.sotService.getLandingExportData(this.filter).subscribe(
        (result: any[]) => {
          this.loaderService.setLoaderStatus(true);
          if (
            this.selectedTabIndex === 0 &&
            this.sotRequestList &&
            this.sotRequestList.length > 0
          ) {
            let sotExportDataList: any = [];
            // From tab variables.
            sotExportDataList = result.filter(
              (x) => x.gridType.toUpperCase() === 'F'
            );
            var exportData = [];
            sotExportDataList.forEach((x) => {
              exportData.push({
                'Request ID': x.sotRequestNumber,
                'Order Date': this.datePipe.transform(
                  x.fromRequestDate,
                  MasterConstants.DATE_MMDDYYYY
                ),
                'From Account Name': x.fromAccountName,
                'From Account#': x.fromAccount,
                'From Customer PO#': x.fromCustPONumber,
                'To Account Name': x.toAccountName,
                'To Account#': x.toAccount,
                'To Customer PO#': x.toCustPONumber,
                'Product Name': x.productName,
                Treatment: x.treatment,
                'Product Line': x.productLine,
                'Item Number': x.itemNumber,
                Quantity: x.quantity + ' ' + x.uom,
                Status: x.requestStatus === 'SUBMITTED' ? 'PENDING' : x.requestStatus,
              });
            });
            this.excelService.exportAsExcelFile(exportData, 'TransferTo');
          } else if (
            this.selectedTabIndex === 1 &&
            this.sotToRequestList &&
            this.sotToRequestList.length > 0
          ) {
            let ToExportSotDataList: any = [];
            // To tab variables.
            ToExportSotDataList = result.filter(
              (x) => x.gridType.toUpperCase() === 'T'
            );
            var exportData = [];
            this.loaderService.setLoaderStatus(true);
            ToExportSotDataList.forEach((x) => {
              exportData.push({
                'Request ID': x.sotRequestNumber,
                'Order Date': this.datePipe.transform(
                  x.toRequestDate,
                  MasterConstants.DATE_MMDDYYYY
                ),
                'From Account Name': x.fromAccountName,
                'From Account#': x.fromAccount,
                'From Customer PO#': x.fromCustPONumber,
                'To Account Name': x.toAccountName,
                'To Account#': x.toAccount,
                'To Customer PO#': x.toCustPONumber,
                'Product Name': x.productName,
                Treatment: x.treatment,
                'Product Line': x.productLine,
                'Item Number': x.itemNumber,
                Quantity: x.quantity + ' ' + x.uom,
                Status: x.requestStatus,
              });
            });
            this.excelService.exportAsExcelFile(exportData, 'TransferFrom');
            this.loaderService.setLoaderStatus(false);
          } else if (
            this.selectedTabIndex === 2 &&
            this.sotRequestDraftList &&
            this.sotRequestDraftList.length > 0
          ) {
            let draftExportSotDataList: any = [];
            // Draft tab variables.
            draftExportSotDataList = result.filter(
              (x) => x.gridType.toUpperCase() === 'D'
            );
            var exportData = [];
            this.loaderService.setLoaderStatus(true);
            draftExportSotDataList.forEach((x) => {
              exportData.push({
                'Request ID': x.sotRequestNumber,
                'Order Date': this.datePipe.transform(
                  x.draftDate,
                  MasterConstants.DATE_MMDDYYYY
                ),
                'From Account Name': x.fromAccountName,
                'From Account#': x.fromAccount,
                'From Customer PO#': x.fromCustPONumber,
                'To Account Name': x.toAccountName,
                'To Account#': x.toAccount,
                'To Customer PO#': x.toCustPONumber,
                'Product Name': x.productName,
                Treatment: x.treatment,
                'Product Line': x.productLine,
                'Item Number': x.itemNumber,
                Quantity: x.quantity + ' ' + x.uom,
                Status: x.requestStatus,
              });
            });
            this.excelService.exportAsExcelFile(
              exportData,
              'DraftsSotRequests'
            );
            this.loaderService.setLoaderStatus(false);
          }

          this.loaderService.setLoaderStatus(false);
        },
        (error) => {
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
  }
  showText() {
    this.isShow = !this.isShow;
  }
}
